import { HotelResult } from '@/api.ts'
import React from 'react'

interface HotelCardProps {
  hotel: HotelResult
}

const HotelCard: React.FC<HotelCardProps> = ({ hotel }) => {
  if (!hotel) {
    return null
  }

  // Extract hotel details
  // const hotelId = hotel.id
  const hotelName: string = hotel.name
  const imageUrl: string = hotel.imageUrl
  const checkInDate: string = hotel.checkInDate
  const checkOutDate: string = hotel.checkOutDate
  const price: string = hotel.price
  const landingUrl: string = hotel.landingUrl

  return (
    <a
      href={landingUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'block',
        width: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.24)',
        border: '1px solid #e0e0e0',
        marginBottom: '16px',
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      {/* Hotel Image */}
      <div
        style={{
          width: '100%',
          height: '160px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f0f0f0',
          overflow: 'hidden',
        }}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={hotelName || 'Hotel image'}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
            onError={e => {
              // Handle image loading errors
              e.currentTarget.style.display = 'none'
              const parent = e.currentTarget.parentElement
              if (parent) {
                const fallbackText = parent.querySelector('.fallback-text')
                if (fallbackText instanceof HTMLElement) {
                  fallbackText.style.display = 'block'
                }
              }
            }}
          />
        ) : null}
      </div>

      {/* Hotel Info */}
      <div style={{ padding: '12px' }}>
        {/* Hotel Name */}
        <div
          style={{
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {hotelName}
        </div>

        {/* Check-in/out Dates */}
        <div
          style={{
            fontSize: '12px',
            color: '#666',
            marginBottom: '8px',
          }}
        >
          Check In/Out: {checkInDate} / {checkOutDate}
        </div>

        {/* Price */}
        <div
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: 'var(--vela-primary-color, #1976d2)',
            textAlign: 'right',
          }}
        >
          {price}
        </div>
      </div>
    </a>
  )
}

export default HotelCard
